'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCoreComponent = getCoreComponent;
function getCoreComponent(Component) {
  var node = Component;
  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/decorators/utils.js
// module id = 131
// module chunks = 0 1